import { render, staticRenderFns } from "./LoyaltySettingExclusionsDiscount.vue?vue&type=template&id=5abc3bd6&scoped=true&"
import script from "./LoyaltySettingExclusionsDiscount.vue?vue&type=script&lang=js&"
export * from "./LoyaltySettingExclusionsDiscount.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltySettingExclusionsDiscount.vue?vue&type=style&index=0&id=5abc3bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abc3bd6",
  null
  
)

export default component.exports